import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

import { storeToRefs } from 'pinia'
import { useParameters } from '@/store/Parameters'
import { useUser } from '@/store/User'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  setup(__props) {

const parametersStore = useParameters()
const { goal, pomodoriByCycle } = storeToRefs(parametersStore)

const userStore = useUser()
const { totalPomodoriDone } = storeToRefs(userStore)


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(goal), (i) => {
    return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
      (i <= _unref(totalPomodoriDone))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(" 🟩 ")
          ], 64))
        : (i == _unref(totalPomodoriDone) + 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" ⭕ ")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(" 🟥 ")
            ], 64)),
      (i % _unref(pomodoriByCycle) == 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            (_unref(goal) <= _unref(totalPomodoriDone))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" 🟩 ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (i !== _unref(goal))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" 🟨 ")
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
          ], 64))
        : _createCommentVNode("", true)
    ], 64))
  }), 128))
}
}

})